import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import styles from './styles';

const ExpandableList = (props) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleClick = () => { setOpen(!open); };

  const {
    title,
    list,
  } = props;
  const selectedCount = list.length || 0;
  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      className={classes.root}
    >
      <ListItem classes={{ root: classes.listButton }} button onClick={handleClick}>
        <ListItemText primary={`${title} (${selectedCount})`} />
        {open
          ? <ExpandLess className={classes.dropdownIndicator} />
          : <ExpandMore className={classes.dropdownIndicator} />
        }
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {selectedCount > 0 ?
          list.map((obj) => (
            <List key={obj.key} component="div" disablePadding>
              <ListItem button className={classes.listItem}>
                <ListItemText primary={obj.value} />
              </ListItem>
            </List>
          ))
          :
          <List component="div" disablePadding>
            <ListItem button className={classes.listItem}>
              <ListItemText primary={'No results'} />
            </ListItem>
          </List>
        }
      </Collapse>
    </List>
  );
};

ExpandableList.propTypes = {
  title: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  })),
};

export default ExpandableList;
